import React from 'react';
import LobbyView from './views/LobbyView/LobbyView';
import CreateOwnParlayView from "./views/CreateOwnParlayView/CreateOwnParlayView";
import TestView from "./views/TestView/TestsView";
import MyAccountView from "./views/MyAccountView/MyAccountView";
import MyProfileView from "./views/MyAccountView/MyProfileView/MyProfileView";
import MyPicksView from "./views/MyAccountView/MyPicksView/MyPicksView";
import WithdrawFundsView from "./views/MyAccountView/WithdrawFundsView/WithdrawFundsView";
import TransactionHistoryView from "./views/MyAccountView/TransactionHistoryView/TransactionHistoryView";
import MyOngoing from "./components/MyOngoing/MyOngoing";
import MyLast30Days from "./components/MyLast30Days/MyLast30Days";
import MyAllTime from "./components/MyAllTime/MyAllTime";
import FAQView from "./views/FaqView/FAQView";
import HowToPlayView from "./views/HowToPlayView/HowToPlayView";
import SignUpView from "./views/SignUpView/SignUpView";
import TermsOfUseView from "./views/TermsOfUseView/TermsOfUseView";
import PrivacyPolicyView from "./views/PrivacyPolicyView/PrivacyPolicyView";
import LandingPageView from "./views/LandingPageView/LandingPageView";
import PreSelectedParlaysView from "./views/PreSelectedParlaysView/PreSelectedParlaysView";
import PicksView from "./views/PicksView/PicksView";
import ProtectedRoute from "./ProtectedRoute";
import GeoRestrictedView from "./views/GeoRestrictedView/GeoRestrictedView";
import LobbyRedirect from "./components/LobbyRedirect/UrlRedirectionService";

const routesConfig = [
    {
        path: '/',
        exact: true,
        element: <LandingPageView />
    },
    {
        path: 'howtoplay',
        element: <HowToPlayView/>,

    },
    {
        path: 'lobby',
        element: <LobbyView/>,
        children: [
            {
                path: '',
                element: <LobbyRedirect/>,
            },
            {
                path: 'CreateYourOwn',
                element: <CreateOwnParlayView/>,
            },
            {
                path: 'Picks/:parlayId',
                element: <PicksView />
            }
        ]
    },
    {
        path: 'faq',
        element: <FAQView/>,
    },
    {
        path: 'termsofuse',
        element: <TermsOfUseView/>,
    },
    {
        path: 'privacypolicy',
        element: <PrivacyPolicyView/>,
    },
    {
        path: 'contactus',
        element: <div>Contact Us</div>,
    },
    {
        path: 'register',
        element: <SignUpView/>,
    },
    {
        path: 'myaccount',
        element: <ProtectedRoute>
                    <MyAccountView/>
                </ProtectedRoute>,
        children: [
            {
                path: 'myprofile',
                element: <MyProfileView/>,
            },
            {
                path: 'mypicks',
                element: <MyPicksView/>,
                children: [
                    {
                        path: 'ongoing',
                        element: <MyOngoing/>,
                    },
                    {
                        path: 'lastthirtydays',
                        element: <MyLast30Days/>,
                    },
                    {
                        path: 'alltime',
                        element: <MyAllTime/>,
                    }
                ]
            },
            {
                path: 'withdrawfunds',
                element: <WithdrawFundsView/>,
            },
            {
                path: 'transactionhistory',
                element: <TransactionHistoryView/>,
            },
        ]
    },
    {
        path: 'restricted',
        element: <GeoRestrictedView/>,
    },
    {
        path: 'test',
        element: <TestView/>,
    },
    {
        path: '*',
        element: <div>Not Found</div>
    }
];

export default routesConfig;
